module.exports = __webpack_public_path__ + "static/media/shop-banner.c48fc748.jpg";